const REGEX_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;

/** Escapes `value` so a `RegExp` matches it literally. */
export const escapeRegExp = (value: string): string =>
    value.replace(REGEX_SPECIAL_CHARACTERS, "\\$&");
